<template>
  <!-- 敏感词库 -->
  <div class="sensitive-keywords-rule-list">
    <div class="container">
      <!-- 搜索条件 -->
      <div style="text-align: right; margin-bottom: 10px">
        <el-button
          type="primary"
          size="medium"
          @click="addKeywords"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1804') : false
          "
        >
          新 建
        </el-button>
      </div>

      <!-- 表格 -->
      <div class="sensitive-keywords-rule-list-table">
        <el-table
          v-loading="tableLoading"
          :header-cell-style="{ background: '#F5F5F5' }"
          :data="sensitiveKeywordsRuleListData"
          style="width: 100%"
        >
          <el-table-column
            v-for="item in tableHeader"
            :key="item.prop"
            :label="item.label"
            :prop="item.prop"
            :width="item.width"
            :fixed="item.fixed"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'create_time'">
                {{ scope.row.create_time | dateFormat }}
              </div>

              <div v-else>
                {{
                  JSON.stringify(scope.row[item.prop]) === "null"
                    ? ""
                    : scope.row[item.prop]
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="medium"
                @click="delBtn(scope.row)"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1805') : false
                "
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 新增规则 -->
    <el-dialog
      title="设置敏感词拦截规则"
      :visible.sync="dialogRules"
      width="600px"
      custom-class="custom-keywordsRules-drawer"
    >
      <div class="add-keywords-rules">
        <el-form
          ref="ruleForm"
          :model="addRulesForm"
          :rules="rules"
          label-width="80px"
        >
          <el-form-item
            label="规则名称"
            prop="rule_id_name"
            class="rule-id-name"
          >
            <el-input
              v-model="addRulesForm.rule_id_name"
              maxlength="20"
              clearable
              placeholder="请输入"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="使用范围" prop="rule_limit">
            <el-select
              v-model="addRulesForm.rule_limit"
              clearable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in limitOptions"
                :key="item.rule_limit"
                :label="item.rule_limit_name"
                :value="item.rule_limit"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="拦截类型" prop="type">
            <el-select
              v-model="addRulesForm.type"
              clearable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.type"
                :label="item.type_name"
                :value="item.type"
              />
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button @click="dialogRules = false">取 消</el-button>
            <el-button type="primary" @click="confirmRulesBtn('ruleForm')"
              >确 定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import template from "@/api/template";
export default {
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  data() {
    return {
      sensitiveKeywordsRuleListForm: {
        keywords_name: "",
        type: "",
      },
      typeOptions: [],
      limitOptions: [],
      tableHeader: [
        {
          label: "规则名称",
          prop: "rule_id_name",
          width: "auto",
          fixed: "left",
        },
        {
          label: "使用范围",
          prop: "rule_limit_str",
          width: "auto",
          fixed: false,
        },
        {
          label: "拦截类型",
          prop: "type_str",
          width: "auto",
          fixed: false,
        },
        {
          label: "创建时间",
          prop: "create_time",
          width: "auto",
          fixed: false,
        },
      ],
      sensitiveKeywordsRuleListData: [],
      dialogRules: false,
      addRulesForm: {
        rule_id_name: "",
        type: [],
        rule_limit: [],
      },
      rules: {
        rule_id_name: [{ required: true, message: "请输入", trigger: "blur" }],
        type: [{ required: true, message: "请选择", trigger: "change" }],
        rule_limit: [{ required: true, message: "请选择", trigger: "change" }],
      },
    };
  },

  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getsensitivekeywordstype();
    this.getSensitiveKeywordsLimit();
    this.getList();
  },
  methods: {
    // 获取敏感词类型
    getsensitivekeywordstype() {
      template.getsensitivekeywordstype().then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.typeOptions = data.list;
        }
      });
    },
    // 获取敏感词使用场景
    getSensitiveKeywordsLimit() {
      template.getSensitiveKeywordsLimit().then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.limitOptions = data.list;
        }
      });
    },
    getList() {
      this.tableLoading = true;
      let params = Object.assign({}, this.sensitiveKeywordsRuleListForm);
      template.getSensitiveKeywordsRuleList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.total = data.total;
          this.sensitiveKeywordsRuleListData = data.list;
          this.tableLoading = false;
        }
      });
    },
    // 查询
    searchBtn() {
      this.pagination.page = 1;
      this.getList();
    },
    // 删除
    delBtn(row) {
      let { rule_id } = row;

      this.$confirm("确认删除该数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const loading = this.$loading();
          template
            .deleteSensitiveKeywordsRule({ rule_id })
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success("删除成功");
                this.getList();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {});
    },
    // 新增敏感词
    addKeywords() {
      this.addRulesForm = {
        type: "",
        keywords_name: "",
      };
      this.$nextTick(() => {
        this.$refs["ruleForm"] ? this.$refs["ruleForm"].clearValidate() : "";
      });
      this.dialogRules = true;
    },
    confirmRulesBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = _.omit(this.addRulesForm, ["type", "rule_limit"]);
          params.type = this.addRulesForm.type.join(",");
          params.rule_limit = this.addRulesForm.rule_limit.join(",");
          template.addSensitiveKeywordsRule(params).then((res) => {
            let { code } = res;
            if (code === 0) {
              this.$message.success("添加成功");
              this.dialogRules = false;
              this.getList();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.sensitive-keywords-rule-list-table {
  border: 1px solid #f5f5f5;
}
</style>
<style lang="scss">
.custom-keywordsRules-drawer {
  .add-keywords-rules {
    padding: 10px;
    .rule-id-name {
      .el-form-item__content {
        height: auto;
      }
    }
  }
}
</style>
